import { render } from "./Log.vue?vue&type=template&id=2ed2b988&scoped=true"
import script from "./Log.vue?vue&type=script&lang=js"
export * from "./Log.vue?vue&type=script&lang=js"

import "./Log.vue?vue&type=style&index=0&id=2ed2b988&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed2b988"]])

export default __exports__